@if (isImpersonating) {
  <div class="impersonation-banner fixed top-0 left-0 right-0 z-50 bg-mediumseagreen p-2 text-white shadow-bottom">
    <span class="m-2">IMPERSONATING</span>
    <button type="button" class="m-2 underline" (click)="stopImpersonating()">
      Return to admin dashboard
    </button>
  </div>
}

<header class="portal-header fixed left-0 right-0 z-40 bg-nav-bg-blue text-white shadow-md py-3"
  [class.top-10]="isImpersonating"
  [class.top-0]="!isImpersonating">
  <div class="grid min-h-[5.5rem] grid-cols-[1fr_auto_1fr] items-center gap-3 px-4 sm:px-6">
    <div class="justify-self-start">
      <button type="button"
        class="block cursor-pointer border-0 bg-transparent p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white focus-visible:outline-offset-4"
        aria-label="Return to dashboard"
        (click)="navigateToDashboard()">
        <img
          src="assets/images/primary_green-white_notag-CMYK.png"
          alt="Iowa Ortho"
          class="h-auto w-28 sm:w-36 max-[380px]:w-20"
        >
      </button>
    </div>

    <div class="min-w-0 text-center leading-tight">
      <p class="text-base font-semibold sm:text-lg lg:text-xl max-[470px]:text-sm max-[380px]:text-xs">{{ portalTitle }}</p>
      <p class="mt-1 text-[0.6875rem] sm:text-xs lg:text-sm max-[380px]:mt-0 max-[380px]:text-[0.625rem]">Welcome, {{ userData?.firstName ?? '' }}</p>
    </div>

    <div class="flex items-center gap-1 justify-self-end">
      <button
        type="button"
        class="h-11 w-11 rounded-full border-2 border-white  !bg-green text-lg font-bold leading-none text-nav-bg-blue"
        [matMenuTriggerFor]="avatarMenu"
      >
        {{ userInitial }}
      </button>
      <button
        type="button"
        mat-icon-button
        class="text-white"
        [matMenuTriggerFor]="avatarMenu"
      >
        <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
      </button>

      <mat-menu #avatarMenu="matMenu" xPosition="before">
        @if (!isImpersonating) {
          <button mat-menu-item (click)="navigateToPreferences()">
            <mat-icon fontIcon="settings"></mat-icon>
            <span>Account Preferences</span>
          </button>
        }
        <button mat-menu-item class="!text-red-700" (click)="handleLogout()">
          <mat-icon class="!text-red-700" fontIcon="logout"></mat-icon>
          <span>Log out</span>
        </button>
      </mat-menu>
    </div>
  </div>
</header>

<div class="portal-header-spacer" [class.impersonating]="isImpersonating" aria-hidden="true"></div>
